<style>
.table td{text-align:center!important;}
</style>
<template>
  <div class="col-lg-12">
    <div class="main-card mb-3 card">
      <div class="card-body">
        <h5 class="card-title">배너관리</h5>
        <p style="font-size:15px;margin-top:10px;">
          - 캠퍼스별 배너는 <span style="font-weight:bold; color:red;">최대 3개</span>까지 등록 가능합니다.<br />
          - 배너이미지는 가로 <span style="font-weight:bold; color:red;">300px ,세로 150px</span>로 등록해주셔야합니다.<br />
          - 연결될 주소는 풀 주소로 넣어주시고,새로운 창으로 열립니다.
        </p>
        <div class="sub_title">CAMPUS게시판 → 배너관리</div>


<table class="table" >
  <tr>
   <th>진열중인 배너 </th>
    <th>파일업로드 </th>
    <th>링크주소 </th>
    <th>등록 </th>
  </tr>
  <tr>
    <td>1번 배너 </td>
    <td><input type="file" /> </td>
    <td><input type="text" style="width:100%;" /> </td>
    <td><button class="btn btn-primary btn-sm">등록</button></td>
  </tr>
  <tr>
    <td>2번 배너 </td>
    <td><input type="file" /> </td>
    <td><input type="text" style="width:100%;" /> </td>
    <td><button class="btn btn-primary btn-sm">등록</button></td>
  </tr>
  <tr>
    <td>3번 배너 </td>
    <td><input type="file" /> </td>
    <td><input type="text" style="width:100%;" /> </td>
    <td><button class="btn btn-primary btn-sm">등록</button></td>
  </tr>
</table>

      </div>
    </div>
  </div>


</template>

<style>
    .modal-footer {border-top:none;}
    .table td{text-align:left;}
</style>



<script>
// @ is an alias to /src

import Tree from "../components/Tree";
import treeBtn from "../components/treeBtn"
import QueryGrid from "../components/QueryGrid"
import axios from "axios";
export default {
  name: 'Home',
  components: {
    Tree,
    treeBtn,
    QueryGrid
  },
  mounted(){
  },
  methods: {
    addPopup(){
                axios({
            method: this.selPopup.id ? 'patch' : 'post',
            url: '/popups' + (this.selPopup.id ? ('/' + this.selPopup.id) : ''),
            data: this.selPopup,
            headers: {
              'Content-Type': 'application/json',
            },
          }).then((response) => {
            if (response.data.error) {
              $.notify({
                // options
                message: '데이터를 조회할 수 없습니다. ' + response.data.error
              }, {
                // settings
                type: 'danger',
                z_index: 9999
              });
            } else {
               $.notify({
                // options
                message: '처리되었습니다'
              }, {
                // settings
                type: 'success',
                z_index: 9999
              });
              this.$refs.qg.search();
            }


          });
    },
    delPopup(){
                axios({
            method: 'delete',
            url: '/popups/' + this.selPopup.id,
            headers: {
              'Content-Type': 'application/json',
            },
          }).then((response) => {
            if (response.data.error) {
              $.notify({
                // options
                message: '데이터를 조회할 수 없습니다. ' + response.data.error
              }, {
                // settings
                type: 'danger',
                z_index: 9999
              });
            } else {
               $.notify({
                // options
                message: '처리되었습니다'
              }, {
                // settings
                type: 'success',
                z_index: 9999
              });
              this.$refs.qg.search();
            }


          });
    },
    loadPopup(id){
                axios({
            method: 'get',
            url: '/popups/' + id
          }).then((response) => {
            if (response.data.error) {
              $.notify({
                // options
                message: '데이터를 조회할 수 없습니다. ' + response.data.error
              }, {
                // settings
                type: 'danger',
                z_index: 9999
              });
            } else {
              this.selPopup = response.data.result;
              this.selPopup.show_in_pchome = response.data.result.show_in_pchome == "1"
              this.selPopup.show_in_mobilehome = response.data.result.show_in_mobilehome == "1"
              this.selPopup.show_in_study = response.data.result.show_in_study == "1"
              this.selPopup.show_in_usersite = response.data.result.show_in_usersite == "1"
              this.selPopup.show_in_intro = response.data.result.show_in_intro == "1"
              this.selPopup.active = response.data.result.active == "1"
            }


          });
    },
          uploadImage() {
        var input = document.createElement('input');
        input.type = 'file';
        input.accept = "image/*";

        input.onchange = e => {
          const uploadFile = e.target.files[0]
          const formData = new FormData()
          formData.append('userfile', uploadFile)

          axios({
            method: 'post',
            url: 'https://s.mypathkr.com/upload',
            data: formData,
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }).then((response) => {
            if (response.data.error) {
              $.notify({
                // options
                message: '데이터를 조회할 수 없습니다. ' + response.data.error
              }, {
                // settings
                type: 'danger',
                z_index: 9999
              });
            } else {
              this.selPopup.image_url = response.data.url
            }


          });

        }

        input.click();
      },
      creating(){
        this.selPopup = {
        "title": "",
        "show_in_pchome": false,
        "show_in_mobilehome": false,
        "show_in_usersite": false,
        "show_in_study": false,
        "show_in_intro": false,
        "biz_ids": [],
        "size_width": "",
        "size_height": "",
        "start_date": "0000-00-00T00:00:00",
        "end_date": "0000-00-00T00:00:00",
        "active": true,
        "image_url": "",
        "link_href": "",
        "m_link_href": "",
        "target": "",
        "m_target": ""

      }

      },
  },
  data(){
    return {
      records: [],
      selPopup: {
        "title": "",
        "show_in_pchome": false,
        "show_in_mobilehome": false,
        "show_in_usersite": false,
        "show_in_study": false,
        "show_in_intro": false,
        "biz_ids": [],
        "size_width": "",
        "size_height": "",
        "start_date": "0000-00-00T00:00:00",
        "end_date": "0000-00-00T00:00:00",
        "active": true,
        "image_url": "",
        "link_href": "",
        "m_link_href": "",
        "target": "",
        "m_target": "",

      },
      config: {

    "name": "팝업",
    "req_endpoint": "/popups",
    "default_limit": 20,
    "search_fields": [
        {
            "id": "businesses",
            "name": "표시대상",
            "type": "business" // business, date, datetime,
        },
        {
            "id": "show_filter",
            "name": "표시위치",
            "type": "switch",
            "filter_type": {
                "pchome": "PC홈페이지",
                "mobilehome": "모바일홈페이지",
                "usersite": "학원홈페이지",
                "study": "학습관",
                "intro": "인트로"
            }
        },

        {
            "id": "date_filter",
            "name": "날짜검색",
            "type": "date",
            "filter_type": {
                "created_at": "작성일",
                "start_date": "시작일",
                "end_date": "종료일",
                "updated_at": "수정일"
            }
        },

                {
            "id": "active",
            "name": "사용",
            "type": "switch",
            "filter_type": {
                "true": "사용",
                "false": "미사용"
            }
        },
        {
            "id": "target",
            "name": "대상",
            "type": "switch",
            "filter_type": {
                "current": "현재 창",
                "_blank": "새 탭"
            }
        },
        {
            "id": "search",
            "name": "키워드검색",
            "type": "text",
            "placeholder": "제목/링크"
        },
    ],
    "columns": [
        {
            "id": "id",
            "sortable": true,
            "name": "#",
            "excel_print": v=>{return v.id}
        },
        {
            "id": "title",
            "sortable": true,
            "name": "제목",
            "excel_print": v=>{return v.title}
        },
        {
            "id": "title",
            "name": "표시위치",
            "excel_print": v=>{return ''}
        },
        {
            "id": "width",
            "sortable": true,
            "name": "가로",
            "excel_print": v=>{return v.width}
        },
        {
            "id": "height",
            "sortable": true,
            "name": "세로",
            "excel_print": v=>{return v.height}
        },
        {
            "id": "start_date",
            "sortable": true,
            "name": "시작일",
            "excel_print": v=>{return v.start_date}
        },
        {
            "id": "end_date",
            "sortable": true,
            "name": "종료일",
            "excel_print": v=>{return v.end_date}
        },
        {
            "id": "active",
            "sortable": true,
            "name": "사용여부",
            "excel_print": v=>{return v.active}
        },
         {
            "id": "target",
            "name": "표시방법",
            "sortable": true,
            "excel_print": v=>{return v.target}
        },
        {
            "id": "created_at",
            "name": "생성일",
            "sortable": true,
            "excel_print": v=>{return v.created_at}
        },
        {
            "id": "act",
            "name": "액션"
        }
    ],
      }
    }
  }
}
</script>
